;(function () {
  angular
    .module('contrast.applications.modals')
    .controller('AppLicenseModalInstanceCtrl', AppLicenseModalInstanceCtrl)

  function AppLicenseModalInstanceCtrl(
    $scope,
    $uibModalInstance,
    logger,
    app,
    licenses,
    LicenseFactory,
    ErrorService
  ) {
    'ngInject'

    $scope.app = app
    $scope.licenses = licenses

    $scope.apply = function () {
      LicenseFactory.applyLicense(app.app_id).then(
        function (response) {
          logger.logSuccess(response.data.messages[0])
          $uibModalInstance.close()
        },
        function (response) {
          ErrorService.processError(response)
          $uibModalInstance.close()
        }
      )
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
